export default "__VITE_ASSET__a692c7c2__"